import * as React from "react";
import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";

// Import styles
import "./styles/posts.scss";

// Bootstrap imports
import { Button, Card, Col, Container, Row } from "react-bootstrap";

const Team = (props) => {
  return (
    <section className="featured-posts team">
      <div className="overlay" />
      <Container className="posts-container">
        <Row>
          <div className="headline">
            <h2 className="shout">Our Team:</h2>
          </div>
        </Row>
        <Row className="posts">
          {props.data.nodes.map(
            ({ id, excerpt, featuredImage, teamFields, title, uri }) => (
              <Col className="post fade-in-slow" xs={12} md={6} lg={4} key={id}>
                <Card>
                  <GatsbyImage
                    image={
                      featuredImage.node.localFile.childImageSharp
                        .gatsbyImageData
                    }
                    alt="test"
                  />
                  <Card.Body>
                    <div className="text">
                      <h3 className="declare">{title}</h3>
                      <h4 className="whisper">{teamFields.title}</h4>
                      <div
                        className="talk body"
                        dangerouslySetInnerHTML={{ __html: excerpt }}
                      />
                      <Link to={`${uri}`}>
                        <Button variant="accent">Read More</Button>
                      </Link>
                      <div className="email">
                        <a href={`mailto:${teamFields.email}`}>
                          {teamFields.email}
                        </a>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            )
          )}
        </Row>
      </Container>
    </section>
  );
};

export default Team;
